export default __webpack_public_path__ + "static/media/team96.0683f558.JPG";